module.exports = __webpack_public_path__ + "static/4-228ae94cdae532576f332c1c13ef9c16.jpg";